import { createFileRoute } from "@tanstack/react-router";
import AnthemCaInsurance, { config } from "@/pages/AnthemCaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/anthem-ca-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Anthem CA TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Anthem California coverage for TMS, SAINT TMS, and SPRAVATO. Learn about prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Anthem CA TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Anthem California coverage for TMS, SAINT TMS, and SPRAVATO. Learn about prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/anthem-ca-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/anthem-ca-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnthemCaInsurance />;
}
